
import Vue from "vue";

export default Vue.extend({
  props: {
    label: {
      type: String
    },
    values: {
      type: Array
    },
    value: {
      type: Array<any>
    }
  },
  computed: {
    allItemsSelected(): boolean {
      return (
        ((this.value as any[]) || []).length >=
        ((this.values as any[]) || []).length
      );
    }
  },
  methods: {
    toggleAll() {
      this.$emit(
        "input",
        (this as any).allItemsSelected ? [] : [...(this as any).values]
      );
    },
    toggleItem(item: any) {
      const values = [...(this as any).value];
      const index = values.indexOf(item);

      if (index !== -1) {
        values.splice(index, 1);
      } else {
        values.push(item);
      }

      this.$emit("input", values);
    }
  }
});
